import { BasicParallelEnumerable } from "../BasicParallelEnumerable.js";
import { nextIterationAsync } from "./_nextIterationAsync.js";
export const eachAsync = (source, action) => {
    const dataFunc = nextIterationAsync(source, async (x) => {
        await action(x);
        return x;
    });
    return new BasicParallelEnumerable(dataFunc);
};
